export default __webpack_public_path__ + "static/media/no-image-circle.daf88596.png";